import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si recién empiezo como manicurista?',
    a: 'Sí. De hecho es el mejor momento para empezar con sistema. No vas a tener que desaprender malos hábitos ni reorganizar lo que ya tenés. Empezás bien desde el día 1.'
  }, {
    q: '¿Sirve si ya tengo experiencia y clientas fijas?',
    a: 'Absolutamente. Las manicuristas con más experiencia son las que más valoran tener los sistemas ordenados porque saben exactamente cuánto tiempo y dinero les cuesta no tenerlos.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar el pago recibís un email con el enlace de descarga en menos de 5 minutos. Todo en formato PDF, listo para abrir desde el celular, tablet o computadora.'
  }, {
    q: '¿Es material argentino o genérico?',
    a: '100% argentino. Los scripts están en el español rioplatense que usás todos los días. Los documentos legales respetan la normativa argentina. Los precios y referencias son locales.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Si lo abrís, lo revisás y no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios. Sin burocracia. Tu palabra alcanza.'
  }, {
    q: '¿Lo puedo imprimir?',
    a: 'Sí. Todos los PDFs están diseñados para funcionar tanto en pantalla como impresos. Las planillas y checklists están optimizados para funcionar perfectamente en papel.'
  }];
  return <section className="py-14 px-4 max-w-3xl mx-auto" data-id="element-111">
      <FadeIn data-id="element-112">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-113">
          <span className="text-4xl" data-id="element-114">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-115">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-116" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-800 rounded-xl bg-gray-900/50 overflow-hidden" data-id="element-117">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-118">
        <span className="font-bold text-lg text-gray-200" data-id="element-119">{question}</span>
        <ChevronDown className={`text-pink-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-120" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-121">
        <p className="text-gray-400 leading-relaxed" data-id="element-122">{answer}</p>
      </div>
    </div>;
}